import * as Collapse from 'bootstrap/js/dist/collapse';

let expandableList = {};

expandableList = {
    expandByDefaultInDesktop: function (elementId) {
        if (window.innerWidth > 990) {
            const myCollapse = document.getElementById(elementId);
            if (myCollapse !== null && !myCollapse.classList.contains("show")) {
                const bsCollapse = new Collapse(myCollapse, {
                    close: true
                });
            }
        }
    },
    listenToEvents: function () {
        var mobileNav = document.getElementById('mobile-nav')
        
        mobileNav.addEventListener('show.bs.collapse', function (e) {
            if (e.target == mobileNav) {
                document.body.classList.add('mobilemenuopen');
            }
        });
        mobileNav.addEventListener('shown.bs.collapse', function () {
            var mobileNav = document.getElementById('mobile-nav');
            var siteHeader = document.getElementById('siteheader');
            var calculatedHeight = siteHeader.getBoundingClientRect().top + window.scrollY + 70; //70 = height of header nav bar

            if (siteHeader.getBoundingClientRect().top == 0) {
                calculatedHeight = 70;
            }
            var height = `calc(100vh - ${calculatedHeight}px)`;
            mobileNav.style.height = height;

        });
        mobileNav.addEventListener('hide.bs.collapse', function (e) {
            if (e.target == mobileNav) {
                document.body.classList.remove('mobilemenuopen');
            }

        });

    },
    hideMenu: function () {
        const mobileMenu = document.getElementById("mobile-nav");
        if (mobileMenu !== null && mobileMenu.classList.contains("show")) {
            const bsCollapse = new Collapse(mobileMenu, {
                close: true
            });
        }
    }
};

export { expandableList };